webpackJsonp([1],{

/***/ "9BgL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Trigger.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Trigger = ({
  name: 'trigger',

  data: function data() {
    return { language: '英語' };
  },


  methods: {
    setLanguage: function setLanguage() {
      this.language === '英語' ? this.language = '日本語' : this.language = '英語';
    }
  },

  computed: {
    greeting: function greeting() {
      return this.language === '英語' ? 'Hello' : 'こんにちは';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e5ec434","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Trigger.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"greet"},[_vm._v("\n    "+_vm._s(_vm.greeting)+"\n  ")]),_vm._v(" "),_c('button',{attrs:{"id":"btn"},on:{"click":_vm.setLanguage}},[_vm._v("Toggle")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_Trigger = (esExports);
// CONCATENATED MODULE: ./src/components/Trigger.vue
function injectStyle (ssrContext) {
  __webpack_require__("9BgL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e5ec434"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Trigger,
  components_Trigger,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_Trigger = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Mocks.vue
//
//
//
//
//
//

/* harmony default export */ var Mocks = ({
  name: 'Mocks',

  computed: {
    getColor: function getColor() {
      return {
        'border': '15px solid ' + this.$store.state.color };
    }
  },

  methods: {
    updateColor: function updateColor(event) {
      this.$store.commit('SET_COLOR', event.target.value);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66f08b18","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mocks.vue
var Mocks_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.getColor)},[_vm._v("\n  色: "),_c('input',{attrs:{"type":"text","placeholder":"色を入力"},on:{"input":_vm.updateColor}})])}
var Mocks_staticRenderFns = []
var Mocks_esExports = { render: Mocks_render, staticRenderFns: Mocks_staticRenderFns }
/* harmony default export */ var components_Mocks = (Mocks_esExports);
// CONCATENATED MODULE: ./src/components/Mocks.vue
function Mocks_injectStyle (ssrContext) {
  __webpack_require__("sbOP")
}
var Mocks_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Mocks___vue_template_functional__ = false
/* styles */
var Mocks___vue_styles__ = Mocks_injectStyle
/* scopeId */
var Mocks___vue_scopeId__ = "data-v-66f08b18"
/* moduleIdentifier (server only) */
var Mocks___vue_module_identifier__ = null
var Mocks_Component = Mocks_normalizeComponent(
  Mocks,
  components_Mocks,
  Mocks___vue_template_functional__,
  Mocks___vue_styles__,
  Mocks___vue_scopeId__,
  Mocks___vue_module_identifier__
)

/* harmony default export */ var src_components_Mocks = (Mocks_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/setData.vue
//
//
//
//
//
//

/* harmony default export */ var setData = ({
  name: 'setData',

  data: function data() {
    return {
      language: '英語'
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6afcfd4a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/setData.vue
var setData_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  Language: "+_vm._s(_vm.language)+"\n")])}
var setData_staticRenderFns = []
var setData_esExports = { render: setData_render, staticRenderFns: setData_staticRenderFns }
/* harmony default export */ var components_setData = (setData_esExports);
// CONCATENATED MODULE: ./src/components/setData.vue
function setData_injectStyle (ssrContext) {
  __webpack_require__("YAYQ")
}
var setData_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var setData___vue_template_functional__ = false
/* styles */
var setData___vue_styles__ = setData_injectStyle
/* scopeId */
var setData___vue_scopeId__ = "data-v-6afcfd4a"
/* moduleIdentifier (server only) */
var setData___vue_module_identifier__ = null
var setData_Component = setData_normalizeComponent(
  setData,
  components_setData,
  setData___vue_template_functional__,
  setData___vue_styles__,
  setData___vue_scopeId__,
  setData___vue_module_identifier__
)

/* harmony default export */ var src_components_setData = (setData_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SetComputed.vue
//
//
//
//
//
//

/* harmony default export */ var SetComputed = ({
  data: function data() {
    return {
      language: 'ja'
    };
  },


  computed: {
    greeting: function greeting() {
      return this.language === '日本語' ? 'おはよう' : 'Good morning';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b4de445","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SetComputed.vue
var SetComputed_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  "+_vm._s(_vm.greeting)+"\n")])}
var SetComputed_staticRenderFns = []
var SetComputed_esExports = { render: SetComputed_render, staticRenderFns: SetComputed_staticRenderFns }
/* harmony default export */ var components_SetComputed = (SetComputed_esExports);
// CONCATENATED MODULE: ./src/components/SetComputed.vue
var SetComputed_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SetComputed___vue_template_functional__ = false
/* styles */
var SetComputed___vue_styles__ = null
/* scopeId */
var SetComputed___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SetComputed___vue_module_identifier__ = null
var SetComputed_Component = SetComputed_normalizeComponent(
  SetComputed,
  components_SetComputed,
  SetComputed___vue_template_functional__,
  SetComputed___vue_styles__,
  SetComputed___vue_scopeId__,
  SetComputed___vue_module_identifier__
)

/* harmony default export */ var src_components_SetComputed = (SetComputed_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//






/* harmony default export */ var App = ({
  components: {
    Trigger: src_components_Trigger,
    Mocks: src_components_Mocks,
    setData: src_components_setData,
    SetComputed: src_components_SetComputed
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59690624","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"box"},[_c('setData')],1),_vm._v(" "),_c('div',{staticClass:"box"},[_c('SetComputed')],1),_vm._v(" "),_c('div',{staticClass:"box"},[_c('Trigger')],1),_vm._v(" "),_c('div',{staticClass:"box"},[_c('Mocks')],1)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("vgKQ")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./src/store.js



vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var state = {
  color: 'pink'
};

var mutations = {
  SET_COLOR: function SET_COLOR(state, color) {
    state.color = color;
  }
};

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: state, mutations: mutations
}));
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/router.js




vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  routes: [{
    path: '/:username',
    component: src_App
  }]
}));
// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  store: store,
  router: router,
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "YAYQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sbOP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vgKQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.6bf1aba1fbd855436882.js